export const FETCH_COURSE_CATEGORIES_REQUEST = 'FETCH_COURSE_CATEGORIES_REQUEST';
export const FETCH_COURSE_CATEGORIES_SUCCESS = 'FETCH_COURSE_CATEGORIES_SUCCESS';
export const FETCH_COURSE_CATEGORIES_FAILURE = 'FETCH_COURSE_CATEGORIES_FAILURE';

export const CREATE_COURSE_CATEGORY_REQUEST = 'CREATE_COURSE_CATEGORY_REQUEST';
export const CREATE_COURSE_CATEGORY_SUCCESS = 'CREATE_COURSE_CATEGORY_SUCCESS';
export const CREATE_COURSE_CATEGORY_FAILURE = 'CREATE_COURSE_CATEGORY_FAILURE';

export const UPDATE_COURSE_CATEGORY_REQUEST = 'UPDATE_COURSE_CATEGORY_REQUEST';
export const UPDATE_COURSE_CATEGORY_SUCCESS = 'UPDATE_COURSE_CATEGORY_SUCCESS';
export const UPDATE_COURSE_CATEGORY_FAILURE = 'UPDATE_COURSE_CATEGORY_FAILURE';

export const DELETE_COURSE_CATEGORY_REQUEST = 'DELETE_COURSE_CATEGORY_REQUEST';
export const DELETE_COURSE_CATEGORY_SUCCESS = 'DELETE_COURSE_CATEGORY_SUCCESS';
export const DELETE_COURSE_CATEGORY_FAILURE = 'DELETE_COURSE_CATEGORY_FAILURE';

export const GET_COURSE_CATEGORY_BY_ID_REQUEST = 'GET_COURSE_CATEGORY_BY_ID_REQUEST';
export const GET_COURSE_CATEGORY_BY_ID_SUCCESS = 'GET_COURSE_CATEGORY_BY_ID_SUCCESS';
export const GET_COURSE_CATEGORY_BY_ID_FAILURE = 'GET_COURSE_CATEGORY_BY_ID_FAILURE';

// Course Actions
export const FETCH_COURSES_REQUEST = 'FETCH_COURSES_REQUEST';
export const FETCH_COURSES_SUCCESS = 'FETCH_COURSES_SUCCESS';
export const FETCH_COURSES_FAILURE = 'FETCH_COURSES_FAILURE';

export const CREATE_COURSE_REQUEST = 'CREATE_COURSE_REQUEST';
export const CREATE_COURSE_SUCCESS = 'CREATE_COURSE_SUCCESS';
export const CREATE_COURSE_FAILURE = 'CREATE_COURSE_FAILURE';

export const UPDATE_COURSE_REQUEST = 'UPDATE_COURSE_REQUEST';
export const UPDATE_COURSE_SUCCESS = 'UPDATE_COURSE_SUCCESS';
export const UPDATE_COURSE_FAILURE = 'UPDATE_COURSE_FAILURE';

export const DELETE_COURSE_REQUEST = 'DELETE_COURSE_REQUEST';
export const DELETE_COURSE_SUCCESS = 'DELETE_COURSE_SUCCESS';
export const DELETE_COURSE_FAILURE = 'DELETE_COURSE_FAILURE';

export const GET_COURSE_BY_ID_REQUEST = 'GET_COURSE_BY_ID_REQUEST';
export const GET_COURSE_BY_ID_SUCCESS = 'GET_COURSE_BY_ID_SUCCESS';
export const GET_COURSE_BY_ID_FAILURE = 'GET_COURSE_BY_ID_FAILURE';

// SME Assignment Actions
export const ASSIGN_SME_TO_COURSE_REQUEST = 'ASSIGN_SME_TO_COURSE_REQUEST';
export const ASSIGN_SME_TO_COURSE_SUCCESS = 'ASSIGN_SME_TO_COURSE_SUCCESS';
export const ASSIGN_SME_TO_COURSE_FAILURE = 'ASSIGN_SME_TO_COURSE_FAILURE';

export const UNASSIGN_SME_FROM_COURSE_REQUEST = 'UNASSIGN_SME_FROM_COURSE_REQUEST';
export const UNASSIGN_SME_FROM_COURSE_SUCCESS = 'UNASSIGN_SME_FROM_COURSE_SUCCESS';
export const UNASSIGN_SME_FROM_COURSE_FAILURE = 'UNASSIGN_SME_FROM_COURSE_FAILURE';

export const GET_COURSE_SMES_REQUEST = 'GET_COURSE_SMES_REQUEST';
export const GET_COURSE_SMES_SUCCESS = 'GET_COURSE_SMES_SUCCESS';
export const GET_COURSE_SMES_FAILURE = 'GET_COURSE_SMES_FAILURE';

// UI State actions
export const CLEAR_COURSE_ERROR = 'CLEAR_COURSE_ERROR';
export const SET_COURSE_LOADING = 'SET_COURSE_LOADING';
export const RESET_COURSE_STATE = 'RESET_COURSE_STATE';
export const SET_SELECTED_CATEGORY = 'SET_SELECTED_CATEGORY';